import React from "react";
import { makeStyles,useTheme } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {ListItem,List,ListItemIcon,ListItemText} from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import PaperComponent from '../components/PackagePaperComponent';
import Grid from '@material-ui/core/Grid';
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import { useHistory } from 'react-router-dom';
import sendEventToEventLogs from '../helpers/events';



const useStyles = makeStyles({
    root: {
        display: 'flex',
        height:'auto',
        width:'100%',
        borderRadius: '15px',
        boxShadow: '0 0 10px 0 #e8e8e8',
        'margin-top': '50px',
        '& h4':{
            color:'#0a0e51',
            'font-family': 'Nunito',
            'font-size':'22px',
            'text-align': 'left',
            'margin-left': '20px',
            'font-weight':'bold',
            'padding-bottom':'10px'
        },
        '& h5':{
            color:'#0a0e51',
            'font-family': 'Nunito',
            'font-size':'16px',
            'text-align': 'left',
            'margin-left': '20px',
             'border-radius': '45px',
             'background-color': '#FFE194',
             display: 'inline',
             'padding-left':'10px',
             'padding-right':'10px',
        }
      },
      
      content: {
        width: '100%',
        height: 'auto',
        '& button':{
          color:'#FFFFFf',
          alignItems:'center',
          marginTop:"30px",
          marginBottom:"10px",
          'background-color':'#2e86f3',
          'font-family': 'Nunito',
          'font-weight': 'bold'
      }

      },
      cover: {
        width: '151px',
        height: '151px',
        'background-size': 'contain',

        
      },
      
      listItem: {
        color:'#0a0e51',
      },


});

const flexContainer = {
    display: 'flex',
    flexDirection: 'row',
    margin: 0,
    'margin-top': '50px',
    'width':"100%"
  };
export default function PackageCardComponent(props) {
    const classes = useStyles();
    const [selectedValue, setSelectedValue] = React.useState(props.packag.structure[0].subId+'');
    const history = useHistory();
    const custom = () => {
      sendEventToEventLogs("AFFINITY_PACKAGE_SELECTION","");
      gtag("event", "plan_selection", {
        price: props.packag.price,
        PackageName : props.packag.title,
        packageId: props.packag.id,
        walletAmount : props.packag.walletAmount,
      });
      history.push('/Checkout',{params: {packageDetails:props.packag
                                                          ,isAuthentic:true
                                                          ,subId:selectedValue}});
    }
   
   
    const handleChange = (event) => {
      
      setSelectedValue(event.target.value);
    };

  
    const benefitsList = (props.packag.content || []).map((benefit) => {
      return (
        <Grid item xs={12} sm={6} md={3}>
        <ListItem className={classes.listItem}>
          <ListItemIcon><CheckCircleIcon style={{ color: "#FFE194" }}/> </ListItemIcon>
          <ListItemText >{benefit}</ListItemText>
        </ListItem>
      </Grid> 
      );
  });

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={12} md={12}>
      <Card className={classes.root}>

        <CardContent className={classes.content}>
          <h4>{props.packag.title} </h4>
          
          <h5>{props.packag.duration} {props.packag.members} members</h5>
        
            <List style={flexContainer} className={classes.list}> 
            <Grid container spacing={3} justify="center">
             {benefitsList}
           
            </Grid>  
          </List> 
          <Box paddingTop='10px' paddingBottom='10px'>
            <h5> Select Your Plan </h5>
          </Box>
        <PaperComponent structure={props.packag.structure} onClick={handleChange} selectedValue={props.selectedValue}/>
        
        <Box textAlign='center' paddingTop='10px'>
            <Button variant="contained"
                color="primary"
                onClick={()=>custom()}
                  className={classes.button}>
                          Avail Now
                </Button>
        </Box>
        </CardContent>
        
          
    
      </Card>
    </Grid>  
    </Grid>  
  );
}